/* @flow */

import { combineReducers } from 'redux';

import virtualBraindateReducer from 'plugin/virtual-braindate/slice/virtualBraindateSlice';
import modalReducer from 'src/shared/app/base/modal/slice/modalSlice';
import uiInterestReducer from 'src/shared/app/interest/reducer/uiInterestReducer';
import uiAuthenticationBaseReducer from 'src/shared/app/authentication/reducer/base/uiAuthenticationBaseReducer';
import uiAuthenticationSupportReducer from 'src/shared/app/authentication/reducer/support/uiAuthenticationSupportReducer';
import braindateReducer from 'src/shared/app/braindate/reducer/uiBraindateReducer';
import uiChatReducer from 'src/shared/app/chat/reducer/uiChatReducer';
import uicheckInReducer from 'src/shared/app/check-in/reducer/uiCheckInReducer';
import uiConversationReducer from 'src/shared/app/conversation/reducer/uiConversationReducer';
import marketReducer from 'src/shared/app/market/reducer/uiMarketReducer';
import uiOnboardingReducer from 'src/shared/app/onboarding/reducer/uiOnboardingReducer';
import uiPreferenceReducer from 'src/shared/app/preference/reducer/uiPreferenceReducer';
import uiAccountReducer from 'src/shared/app/account/base/reducer/uiAccountReducer';
import uiNotificationReducer from 'src/shared/app/notification/reducer/uiNotificationReducer';
import uiSignupReducer from 'src/shared/app/signup/reducer/uiSignupReducer';
import uiNewTopicReducer from 'src/shared/app/topic/new/reducer/uiTopicReducer';
import uiBookingReducer from 'src/shared/app/booking/reducer/uiBookingReducer';
import portalRegistrationSlice from '../portal/notification/slice/portalRegistrationSlice';
import navSliceReducer from 'src/shared/app/nav/slice/navSlice';
import uiHelpButtonReducer from 'src/shared/app/help/reducer/uiHelpButtonReducer';

// $FlowIssue
const uiReducer = combineReducers({
  account: uiAccountReducer,
  authentication: uiAuthenticationBaseReducer,
  braindates: braindateReducer,
  chat: uiChatReducer,
  checkIn: uicheckInReducer,
  conversation: uiConversationReducer,
  helpButton: uiHelpButtonReducer,
  interest: uiInterestReducer,
  modal: modalReducer,
  market: marketReducer,
  notification: uiNotificationReducer,
  onboarding: uiOnboardingReducer,
  preference: uiPreferenceReducer,
  signup: uiSignupReducer,
  support: uiAuthenticationSupportReducer,
  newTopic: uiNewTopicReducer,
  booking: uiBookingReducer,
  virtualBraindate: virtualBraindateReducer,
  portalRegistration: portalRegistrationSlice,
  nav: navSliceReducer,
});

export default uiReducer;
